import React from 'react';

const PalmdaleFooter = () => {
    return (
        <div className={'PalmdaleFooter'}>
            <div>Palmdale Animal Care Center</div>
            <div>38550 Sierra Hwy</div>
            <div>Palmdale, CA 93550</div>
            <div>(661) 575-2888</div>
        </div>
    );
};

export default PalmdaleFooter;
